import { Locale } from './types';

const en_US: Locale = {
  locale: 'en_US',
  DatePicker: {
    weeks: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: 'Today',
    selectDate: 'Select date',
    selectMonth: 'Select month',
    selectYear: 'Select year',
  },
  TimePicker: {
    selectTime: 'Select time',
    now: 'Now',
    okText: 'OK',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel',
  },
  PopConfirm: {
    okText: 'Yes',
    cancelText: 'No',
  },
  Empty: {
    description: 'No Data',
  },
  Table: {
    sortAscend: 'Sort ascending',
    sortDescend: 'Sort descending',
    cancelSort: 'Cancel sort',
    selectAll: 'Select all',
    selectNone: 'Select none',
    emptyText: 'No Data',
  },
  ColorPicker: {
    hex: 'HEX',
    rgb: 'RGB',
    hsb: 'HSB',
  },
  Tour: {
    prevText: 'Previous',
    nextText: 'Next',
    finishText: 'Finish',
  },
};

export default en_US;
